<template>
    <b-container fluid="">
        <b-row>
            <div class="col-sm-12 mt-3">
                <label for="">Tipo reportes</label>
                <select class="form-control form-control-sm" v-model="tipo_reporte">
                    <option value="">Selecciona</option>
                    <option v-if="permisos['inventarios.reportes.corte_caja']?.ver || ES_ROOT" value="corte_caja">Corte
                        de caja
                    </option>
                    <option value="corte_caja_global">Corte de caja global
                    </option>
                    <option v-if="permisos['inventarios.reportes.bitacora']?.ver || ES_ROOT" value="bitacora">Bitacora
                    </option>
                    <option v-if="permisos['inventarios.reportes.consolidado']?.ver || ES_ROOT" value="consolidado">
                        Consolidado
                    </option>
                    <option v-if="permisos['inventarios.reportes.por_producto']?.ver || ES_ROOT" value="porproducto">Por
                        Producto
                    </option>
                    <option v-if="permisos['inventarios.reportes.por_vendedor']?.ver || ES_ROOT" value="porvendedor">Por
                        Vendedor
                    </option>
                    <option v-if="permisos['inventarios.reportes.por_promocion']?.ver || ES_ROOT" value="promociones">
                        Por Promocion
                    </option>
                    <option v-if="permisos['inventarios.reportes.por_vendedor_producto']?.ver || ES_ROOT"
                        value="vededorproducto">Por Producto y Vendedor
                    </option>

                </select>
            </div>
        </b-row>

        <CorteDeCaja v-if="tipo_reporte == 'corte_caja'"></CorteDeCaja>
        <Consolidado v-if="tipo_reporte == 'consolidado'"></Consolidado>
        <ReporteProducto v-if="tipo_reporte == 'porproducto'"></ReporteProducto>
        <Bitacora v-if="tipo_reporte == 'bitacora'"></Bitacora>
        <ReportePorVendedor v-if="tipo_reporte == 'porvendedor'"></ReportePorVendedor>
        <ReportePromociones v-if="tipo_reporte == 'promociones'"></ReportePromociones>
        <ReporteVendedorProducto v-if="tipo_reporte == 'vededorproducto'"></ReporteVendedorProducto>
        <CorteDeCajaGlobal v-if="tipo_reporte == 'corte_caja_global'"></CorteDeCajaGlobal>


    </b-container>
</template>

<script>
    import CorteDeCaja from './CorteDeCaja/CorteDeCaja.vue'
    import Consolidado from './Consolidado/Consolidado.vue'
    import ReporteProducto from './Productos/ReporteProducto.vue'
    import Bitacora from './Bitacora/Bitacora.vue'
    import ReportePorVendedor from './Vendedor/Vendedor.vue'
    import ReportePromociones from './Promociones/ReportePromociones.vue'
    import ReporteVendedorProducto from './VendedorProductos/VendedorProductos.vue'
    import CorteDeCajaGlobal from './CorteDeCajaGlobal/CorteDeCajaGlobal.vue'
    import { mapGetters, mapState } from 'vuex'

    export default {
        name: 'MenuReportes',
        computed: {
            ...mapState(['permisos', 'datos_usuario']),
            ...mapGetters(['ES_ROOT'])
        },
        components: {
            CorteDeCaja,
            Consolidado,
            ReporteProducto,
            Bitacora,
            ReportePorVendedor,
            ReportePromociones,
            ReporteVendedorProducto,
            CorteDeCajaGlobal
        },
        data() {
            return {
                tipo_reporte: ''
            }
        },
        methods: {

        },
    }
</script>

<style></style>